import Client from '@/clients/apiClient';

const resource = 'orders';

export default {
  sale(payload) {
    return Client.post(`${resource}`, payload);
  },
};
